import { Link } from "react-router-dom";

export default function Logo({ variant = "dark" }) {
  return (
    <Link to="/" data-testid="logo-link" className="flex items-center" aria-label="DN STUDIO TECNICO — Home">
      <img
        src="/logo-dn.png"
        alt="DN STUDIO TECNICO"
        width={640}
        height={182}
        className={`h-10 w-auto ${variant === "light" ? "brightness-0 invert opacity-90" : ""}`}
      />
    </Link>
  );
}
